import { useSnackbar as notistackUseSnackbar } from 'notistack'

const useSnackbar = () => {
  const { enqueueSnackbar } = notistackUseSnackbar()

  const successSnackbar = ({ text, duration = 2000  }) =>
    enqueueSnackbar(text, {
      variant: 'success',
      anchorOrigin: { horizontal: 'right', vertical: 'top' },
      style: { zIndex: 9999 },
      autoHideDuration: duration
    })

  const errorSnackbar = ({ text, duration = 3000 }) =>
    enqueueSnackbar(text, {
      variant: 'error',
      anchorOrigin: { horizontal: 'right', vertical: 'top' },
      style: { zIndex: 9999 },
      autoHideDuration: duration
    })

  return { successSnackbar, errorSnackbar }
}

export default useSnackbar
